import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Homepage from './components/homepage/homepage.component'
import AuthForm from './components/auth-form/auth-form.component'
import MyPage from './components/my-page/my-page.component'
import { MyDataProvider } from './context/data-context.component';

function App() {
  return (
    <MyDataProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/auth" element={<AuthForm />} />
          <Route path="/mypage" element={<MyPage />} />
        </Routes>
      </Router>
    </MyDataProvider>
  )
}

export default App;



// import React, { useState } from 'react';
// import axios from 'axios';
// import { highlightText } from './wordFrequency';
// import './App.css'

// function App() {
//   const [image, setImage] = useState(null);

//   const [text, setText] = useState('');

  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];
  //   setImage(file);
  //   setPreviewUrl(URL.createObjectURL(file));
  // }

//   const formatText = (rawText) => {
//     let cleanedText = rawText
//       .replace(/\s+/g, ' ')  // Replace multiple spaces with a single space
//       .replace(/\n+/g, ' ')  // Replace multiple line breaks with a single space
//       .trim();               // Remove leading and trailing spaces
//     // cleanedText = cleanedText
//     //   .replace(/(\.|\?|\!)\s/g, "$1\n");
//     return cleanedText;
//   };

//   const handleUpload = async () => {
//     if (!image) return;
  
//     const reader = new FileReader();
//     reader.onloadend = async () => {
//       const base64Image = reader.result.replace(/^data:image\/[a-z]+;base64,/, '');
//       const VISION_API_KEY = process.env.REACT_APP_GOOGLE_VISION_API_KEY;
  
//       const requestPayload = {
//         requests: [
//           {
//             image: { content: base64Image },
//             features: [{ type: 'TEXT_DETECTION' }]
//           }
//         ]
//       };
  
//       try {
//         const res = await axios.post(
//           `https://vision.googleapis.com/v1/images:annotate?key=${VISION_API_KEY}`,
//           requestPayload
//         );
  
//         // Log the entire response for debugging
//         console.log(res);
  
//         const detectedText = res.data.responses[0]?.fullTextAnnotation?.text || 'No text detected.';
//         const cleanedText = formatText(detectedText);
//         setText(cleanedText);
//       } catch (error) {
//         console.error('Error:', error);
//         setText('Error detecting text.');
//       }
//     };
  
//     reader.readAsDataURL(image);
//   };
  

//   console.log(process.env.REACT_APP_GOOGLE_VISION_API_KEY)
//   return (
//     <div className="container">
//       <h1>Google Vision OCR</h1>
//       <input type="file" accept="image/*" capture="environment" onChange={handleFileChange} />
//       <br />
//       <button onClick={handleUpload}>Upload & Detect Text</button>
//       {previewUrl && <img src={previewUrl} alt="Preview" />}
//       <pre className="text-container">{text}</pre>
//     </div>
//   );
// }

// export default App;
